import React from "react";
import { compareCalendarRows, groupCalendarRows } from "../../utils/assessmentCalendarRules";
import CalendarAssessmentRow from "./CalendarAssessmentRow";

const CalendarScheduledList = ({
  rows,
  isAdmin,
  today,
  onOpen,
  onRequestToJoin,
  onRefetch,
  emptyMessage = "No scheduled assessments in this range.",
  compact = false,
}) => {
  const sorted = [...(rows || [])].sort(compareCalendarRows);
  const groups = groupCalendarRows(sorted);

  if (!groups.length) {
    return <p className="py-8 text-sm text-gray-500">{emptyMessage}</p>;
  }

  if (!isAdmin && !compact) {
    const requested = groups.filter((group) => !group.parent.is_browse_only);
    const availableToJoin = groups.filter((group) => group.parent.is_browse_only);
    return (
      <div className="space-y-6">
        {requested.length > 0 ? (
          <section>
            <h4 className="text-sm font-semibold text-gray-900">My Requests</h4>
            <p className="mt-0.5 text-xs text-gray-500">
              Assessments you requested or asked to join.
            </p>
            <GroupedRows
              groups={requested}
              isAdmin={isAdmin}
              today={today}
              onOpen={onOpen}
              onRequestToJoin={onRequestToJoin}
              onRefetch={onRefetch}
              compact={compact}
            />
          </section>
        ) : null}
        {availableToJoin.length > 0 ? (
          <section>
            <h4 className="text-sm font-semibold text-gray-900">Available to Join</h4>
            <p className="mt-0.5 text-xs text-gray-500">
              Scheduled multi-sponsor assessments open to your organization.
            </p>
            <GroupedRows
              groups={availableToJoin}
              isAdmin={isAdmin}
              today={today}
              onOpen={onOpen}
              onRequestToJoin={onRequestToJoin}
              onRefetch={onRefetch}
              compact={compact}
            />
          </section>
        ) : null}
      </div>
    );
  }

  return (
    <GroupedRows
      groups={groups}
      isAdmin={isAdmin}
      today={today}
      onOpen={onOpen}
      onRequestToJoin={onRequestToJoin}
      onRefetch={onRefetch}
      compact={compact}
    />
  );
};

function GroupedRows({ groups, isAdmin, today, onOpen, onRequestToJoin, onRefetch, compact }) {
  return (
    <ol className={`divide-y divide-gray-100 ${compact ? "text-sm" : "text-sm leading-6"}`}>
      {groups.map(({ parent, subrows }) => (
        <li key={`${parent.vqa_id}-${parent.sponsor_id || "parent"}`} className="relative">
          <CalendarAssessmentRow
            row={parent}
            isAdmin={isAdmin}
            today={today}
            onOpen={onOpen}
            onRequestToJoin={onRequestToJoin}
            onRefetch={onRefetch}
            compact={compact}
          />
          {subrows.map((row) => (
            <div
              key={`${row.vqa_id}-${row.join_vqa_request_id || row.sponsor_id}`}
              className={`ml-20 border-l-2 border-gray-200 ${compact ? "mt-1 py-1.5 pl-3 pr-1" : "mt-2 py-2 pl-4 pr-2"}`}
            >
              <CalendarAssessmentRow
                row={row}
                isAdmin={isAdmin}
                today={today}
                onOpen={onOpen}
                onRequestToJoin={onRequestToJoin}
                onRefetch={onRefetch}
                isSubrow
                compact={compact}
              />
            </div>
          ))}
        </li>
      ))}
    </ol>
  );
}

export default CalendarScheduledList;
